import { blockIdFromHash } from "@/lib/blockLink";

export function isInternalLink(href?: string | null): boolean {
  if (!href) return false;
  if (typeof window === "undefined") return false;

  const value = href.trim();
  if (!value) return false;

  if (value.startsWith("/") || value.startsWith("#") || value.startsWith("?")) {
    return true;
  }

  try {
    return new URL(value, window.location.origin).origin === window.location.origin;
  } catch {
    return false;
  }
}

export function linkTarget(href?: string | null): "_self" | "_blank" {
  return isInternalLink(href) ? "_self" : "_blank";
}

// The link-click plugin runs at module scope and can't call React hooks, so a
// client component registers router.push here for same-origin navigation.
let navigator: ((href: string) => void) | null = null;

export function setInternalLinkNavigator(fn: ((href: string) => void) | null) {
  navigator = fn;
}

export function navigateInternalLink(href: string) {
  if (typeof window === "undefined") return;

  // A block link into the page already open is a hash-only change. Pushing it through the
  // router would scroll to the top (no element carries that id) and never fire hashchange,
  // which is what BlockLinkFocusExtension listens for — so update the URL by hand.
  try {
    const target = new URL(href, window.location.href);
    if (
      blockIdFromHash(target.hash) &&
      target.pathname === window.location.pathname &&
      target.search === window.location.search
    ) {
      if (target.hash !== window.location.hash) {
        window.history.pushState(null, "", target.href);
      }
      window.dispatchEvent(new Event("hashchange"));
      return;
    }
  } catch {
    // Unparseable href — let the router deal with it.
  }

  if (navigator) {
    navigator(href);
  } else {
    window.location.assign(href);
  }
}
